import { useCallback, useEffect, useMemo } from "react";
import { useQueryLoader, useRelayEnvironment } from "react-relay";
import { createOperationDescriptor, getRequest } from "relay-runtime";
import { useWidgetNoteMockPreview } from "../../WidgetAdd/Categories/WACategoryNote/getWidgetNoteMockPreview";
import { WANotePreviewTemplate } from "../../WidgetAdd/Categories/WACategoryNote/WANotePreviewTemplate";
import { WA_NOTE_PREVIEW_QUERY } from "./WANotePreview";
import {
  WANotePreviewQuery,
  WANotePreviewQuery$rawResponse,
  WANotePreviewQuery$variables,
} from "./__generated__/WANotePreviewQuery.graphql";
const WA_NOTE_MOCK_PREVIEW_DATA_PREFIX = "WA_NOTE_MOCK_PREVIEW_QUERY:";

const dummyInput = (
  index: number,
  dataPrefix: string = WA_NOTE_MOCK_PREVIEW_DATA_PREFIX
) => ({
  id: dataPrefix + index,
  pages: [],
  size: "TWO_X_TWO" as const,
  storecastId: "",
  title: "",
});

export function useWANotePreviewQueryLoader(
  template: WANotePreviewTemplate,
  storecastId: string,
  dataPrefix: string = WA_NOTE_MOCK_PREVIEW_DATA_PREFIX
) {
  const env = useRelayEnvironment();
  const vars = useMemo(
    () =>
      ({
        storecastId,
        input: dummyInput(1),
      }) as WANotePreviewQuery$variables,
    [storecastId]
  );

  const [queryRef, load] = useQueryLoader<WANotePreviewQuery>(
    WA_NOTE_PREVIEW_QUERY
  );

  const previewData = useWidgetNoteMockPreview({
    template,
    dataPrefix: dataPrefix + "0",
  });
  const populateData = useCallback(() => {
    const req = getRequest(WA_NOTE_PREVIEW_QUERY);
    const op = createOperationDescriptor(req, vars);

    const payload: WANotePreviewQuery$rawResponse = {
      dashboard: {
        id: vars.storecastId,
        previewWidgetNote: previewData,
      },
    };
    env.commitPayload(op, payload);
    load(vars);
  }, [env, load, previewData, vars]);

  useEffect(() => populateData(), [populateData]);

  return queryRef;
}
